<template>
    <header class="header">
        <app-modal></app-modal>

    </header>
</template>

<script>
    import AppModal from './freeconnection-modal/FreeConnectionsModal'

    export default {
        components: {
            AppModal
        },

        methods: {
        },
    }
</script>

<style scoped>
    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
</style>
